<template v-if="true">
  <div class="quadro" ref="root" v-if="firstFetchDone && panelWidth">

    <s-alert v-if="frameWorkRequiresAcceptance" :caseId="caseId" >
    </s-alert>

    <s-sf-alert v-if="sfRequiresAcceptance" :caseId="caseId" >
    </s-sf-alert>

    <s-header>
      <template #status v-if="$t('javascript.visual_panel') != ''">
        <h3> <span v-html="negoDetailsnegotiation_status"></span></h3>
        <span v-html="$t('javascript.visual_panel')"></span>
      </template>
      <div class="row">
        <div :class="((btnToShow === 'show-sgc') && negoDetails.your_party.acceptance_locked != 'yes') ? 'col-sm-2' : 'col-sm-2'">
          <a
          style="margin-left:50px;"
          class="btn btn-xs mr-5 btn-success"
          id="dashboard-btn" btn-style="success"
          :href="this.getDashboardLink"
          :title="$t('javascript.dashboard')"
          >
          {{$t('javascript.dashboard')}}
          </a>

        </div>
        <div :class="((btnToShow === 'show-sgc') && negoDetails.your_party.acceptance_locked != 'yes') ? 'col-sm-6' : 'col-sm-8'" style="text-align: center;">
          <div v-if="ourParty.waiting_on_party == true">
            <h4 style="margin-top:0px;background-color:yellow;color:black"><span v-html="this.negoDetails.negotiation_status"></span></h4>
          </div>
          <div v-else>
            <h4 style="margin-top:0px;"><span v-html="negoDetails.negotiation_status"></span></h4>
          </div>

        </div>

        <div :class="((btnToShow === 'show-sgc') && negoDetails.your_party.acceptance_locked != 'yes') ? 'col-sm-4' : 'col-sm-2'" style="text-align:right;">
          <s-button
            id="cancel-end-session-btn" v-if="(btnToShow === 'show-sgc') && negoDetails.your_party.acceptance_locked != 'yes'" btn-style="warning"
            style="margin-right:5px;"
            @click="cancelEndSession" :title="$t('javascript.not_ready_to_check_for')"
            >
            {{ $t('javascript.cancel_end_session') }}
          </s-button>

          <s-button

          v-if="btnToShow === 'help' || btnToShow === 'two' " btn-style="success"
          style="margin-right:50px;"
          :title="(issueDetailList[0].unpreferred_value > issueDetailList[0].preferred_value) ? $t('javascript.drag_the_green_flag_lower') : $t('javascript.drag_the_green_flag_higher')"
          >
          <i class="fa fa-info-circle"></i> {{ $t('javascript.help') }}
          </s-button>
          <s-button
          id="end-session-other-btn" v-if="btnToShow === 'end-session' && otherPartyEndedSession" btn-style="primary"
          style="margin-right:50px;"
          @click="modalsOpen.endSession = true" :title="$t('javascript.agreement_occurs_when')"
          >
            {{ $t('javascript.check_for_agreement') }}
          </s-button>
          <s-button
            style="margin-right:50px;"
            id="end-session-btn" v-else-if="btnToShow === 'end-to-agree'" btn-style="primary"
            @click="modalsOpen.endSession = true" :title="$t('javascript.end_to_agree')"
            >
            {{ $t('javascript.end_for_agreement') }}
          </s-button>

          <s-button
            style="margin-right:50px;"
            id="end-session-btn" v-else-if="btnToShow === 'end-session'" btn-style="primary"
            @click="modalsOpen.endSession = true" :title="$t('javascript.ss_checks_for_agreement')"
            >
            {{ $t('javascript.i_am_done') }}
          </s-button>
          <a
            style="margin-right:50px;"
            class="btn btn-xs mr-5 btn-warning"
            id="reset-btn" v-else-if="btnToShow === 'reset'" btn-style="primary"
            :href="'/negotiations/' + this.negoDetails.id + '/reset_negotiation_last?party_id=' + this.ourParty.id"
            >
            {{ $t('javascript.reset') }}
          </a>

          <s-button
            style="margin-right:50px;"
            id="final-session-btn" v-else-if="btnToShow === 'final-session'" btn-style="default"
            @click="modalsOpen.finalSession = true" :title="$t('javascript.last_chance_to_reach')"
            >
            {{ $t('javascript.declare_final_session') }}
          </s-button>
          <s-button
            id="all-done-btn" v-else-if="btnToShow === 'all-done'" btn-style="danger"
            style="margin-right:50px;"
            @click="checkAgreement" :title="$t('javascript.ready_to_end_this')"
            >
            {{ $t('javascript.end_final') }}
          </s-button>
          <s-button
            id="cancel-end-session-btn" v-else-if="btnToShow === 'cancel-end-session'" btn-style="warning"
            style="margin-right:50px;"
            @click="cancelEndSession" :title="$t('javascript.not_ready_to_check_for')"
            >
            {{ $t('javascript.cancel_end_session') }}
          </s-button>
          <s-button
            id="show-sgc-btn" v-else-if="btnToShow === 'show-sgc'" btn-style="danger"
            style="margin-right:50px;"
            @click="openSgc" :title="$t('javascript.ready_to_end_this')"
            >
            {{ $t('javascript.show_sgc') }}
          </s-button>

          <s-button
            id="cancel-all-done-btn" v-else-if="btnToShow === 'cancel-all-done'" btn-style="warning"
            style="margin-right:50px;"
            @click="cancelDeclareAllDone" :title="$t('javascript.not_ready_to_end_this')"
            >
            {{ $t('javascript.cancel_end_final_session') }}
          </s-button>

          <a
            style="margin-right:50px;"
            class="btn btn-xs mr-5 btn-warning"
            id="cancel-reset-btn" v-else-if="btnToShow === 'cancel-reset'" btn-style="primary"
            :href="'/negotiations/' + this.negoDetails.id + '/cancel_reset_negotiation?party_id=' + this.ourParty.id"
            >
            {{ $t('javascript.cancel_reset') }}
          </a>
        </div>
      </div>
      <template v-if="true">
        <div class="row">
          <party side="left" :status="opponentParty.availability">
            {{ opponentParty.short_name }}
          </party>
          <div class="col-sm-4" style="text-align:center;">
            <h4 v-if="$t('javascript.visual_blind_bidding') != ''">{{ $t('javascript.visual_blind_bidding') }}<sup>SM</sup></h4>
          </div>
          <party side="right" :status="ourParty.availability">
            {{ ourParty.short_name }}
          </party>
        </div>
      </template>
    </s-header>

    <slider
      v-for="issue in issueDetailList"
      :ref="slider215"
      :key="'slider' + issue.issue_id"
      :show-label="negoDetails.show_slider_label"
      :width="panelWidth"
      :issue-details="issue"
      :session-number="sessionNumber"
      :other-party-ended-or-done-session="isFinalSession ? (opponentParty.has_declared_done === 'yes' ? true : false) : (opponentParty.has_ended_session === 'yes' ? true : false)"
      :requires_payment="negoDetails.requires_payment"
      :agreement-reached="agreementReached && issue.agreement_value"
      :ask-for-mediator-perms="askForMediatorPerms"
      :has-ended-session="ourParty.has_ended_session"
      :freeze="negotiationCompleted || frameWorkRequiresAcceptance || sfRequiresAcceptance || flagsEnabled"
      :locked="negoDetails.your_party.acceptance_locked == 'yes'"
      @proposal="savePosition('Proposal', $event, issue.issue_id)"
      @acceptance="savePosition('Acceptance', $event, issue.issue_id)"
      @both="savePosition('ProposalAndAcceptance', $event, issue.issue_id)"
      @asks-to-end-session="checkAgreement"
      @allow-mediator-to-see-secret="allowMediatorToSeeSecret"
    ></slider>

    <s-footer v-if="false">
      <s-button
        id="help-btn" v-if="btnToShow === 'help' || btnToShow == 'two' " btn-style="success"
        :title="$t('javascript.drag_the_green_flag')"
      >
        <i class="fa fa-info-circle"></i> {{ $t('javascript.help') }}
      </s-button>
      <s-button
        id="end-session-other-btn" v-if="btnToShow === 'end-session' && otherPartyEndedSession" btn-style="primary"
        @click="modalsOpen.endSession = true" :title="$t('javascript.agreement_occurs_when')"
      >
        {{ $t('javascript.check_for_agreement') }}
      </s-button>
      <s-button
        id="end-session-btn" v-else-if="btnToShow === 'end-session'" btn-style="primary"
        @click="modalsOpen.endSession = true" :title="$t('javascript.ss_checks_for_agreement')"
      >
        {{ $t('javascript.end_session', {sessionNumber}) }}
      </s-button>
      <s-button
        id="final-session-btn" v-else-if="btnToShow === 'final-session'" btn-style="default"
        @click="modalsOpen.finalSession = true" :title="$t('javascript.last_chance_to_reach')"
      >
        {{ $t('javascript.declare_final_session') }}
      </s-button>
      <s-button
        id="all-done-btn" v-else-if="btnToShow === 'all-done'" btn-style="danger"
        @click="modalsOpen.allDone = true" :title="$t('javascript.ready_to_end_this')"
      >
        {{ $t('javascript.end_final') }}
      </s-button>
      <s-button
        id="cancel-end-session-btn" v-else-if="btnToShow === 'cancel-end-session'" btn-style="warning"
        @click="cancelEndSession" :title="$t('javascript.not_ready_to_check_for')"
      >
        {{ $t('javascript.cancel_end_session') }}
      </s-button>
      <s-button
        id="cancel-all-done-btn" v-else-if="btnToShow === 'cancel-all-done'" btn-style="warning"
        @click="cancelDeclareAllDone" :title="$t('javascript.not_ready_to_end_this')"
      >
        {{ $t('javascript.cancel_end_final_session') }}
      </s-button>
      <template #status v-if="$t('javascript.visual_panel') != ''">
        <h3 v-html="negoDetails.negotiation_status"></h3>
      </template>
      <template #notification>
        <span class="error-msg">
          {{ store.state.errorMessage }}
        </span>
        <span v-if="store.state.offline" class="offline-msg">
          <b>{{ $t('javascript.not_connected') }}</b> {{ $t('javascript.trying_to_reconnect') }}
        </span>
      </template>
    </s-footer>

    <end-session-modal
      v-if="modalsOpen.endSession"
      v-model:value="modalsOpen.endSession"
      :adc-before-final="negoDetails.adc_before_final"
      :other-party-ended-session="otherPartyEndedSession"
      adc
      :adc-unit="adcUnit"
      :adc-secret-extension="this.negoDetails.your_party.acceptance"
      :session-number="sessionNumber"
      @cancel="modalsOpen.endSession = false"
      @ok="endSession"
    ></end-session-modal>
    <survey-modal
      v-if="showSurvey"
      v-model="showSurvey"
      :completed="modalsOpen.negCompleted"
      :party-id="this.ourParty.id"
      :survey-id="this.negoDetails.survey_id"
      @ok="surveyOk"
    ></survey-modal>

    <all-done-modal
      v-show="modalsOpen.allDone"
      v-model:value="modalsOpen.allDone"
      :end="negoDetails.arbitration_enabled"
      :isOpen="modalsOpen.allDone"
      :units="this.issueDetailList[0].issue_format_and_units"
      :expert-neutral-count="negoDetails.expert_neutral_count"
      :end-accepted-by-opponent="opponentParty.arbitration_accepted"
      :opponent-ended-session="isFinalSession ? (opponentParty.has_declared_done === 'yes' ? true : false) : (opponentParty.has_ended_session === 'yes' ? true : false)"
      :opponent-short="this.negoDetails.other_party.short_name"
      :both-acceptance-locked="this.negoDetails.session.final_session === 'yes' && this.negoDetails.your_party.acceptance_locked === 'yes' && this.negoDetails.other_party.acceptance_locked === 'yes'"
      :your-acceptance="this.negoDetails.your_party.acceptance"
      :minSgc="(this.negoDetails.your_party.acceptance > this.negoDetails.other_party.visible) ? this.negoDetails.other_party.visible : this.negoDetails.your_party.acceptance"
      :maxSgc="(this.negoDetails.your_party.acceptance < this.negoDetails.other_party.visible) ? this.negoDetails.other_party.visible : this.negoDetails.your_party.acceptance"
      :grid-step-size="this.issueDetailList[0].grid_increment"
      adc
      :adc-unit="adcUnit"
      :adc-secret-extension="this.negoDetails.your_party.acceptance"
      @cancel="console.log('cancelled');modalsOpen.allDone = false"
      @ok="declareAllDone"
    ></all-done-modal>

    <final-session-modal
      v-if="modalsOpen.finalSession"
      v-model:value="modalsOpen.finalSession"
      @cancel="modalsOpen.finalSession = false"
      @ok="markSessionAsFinal"
    ></final-session-modal>

    <simple-ok-modal v-if="modalsOpen.noAgreement" v-model="modalsOpen.noAgreement">
      {{ $t('javascript.sorry_no_agreement') }}  <!-- Please contact your mediator. -->
    </simple-ok-modal>

    <simple-ok-modal v-if="modalsOpen.sessionNoAgreement" v-model="modalsOpen.sessionNoAgreement">
      <p>{{ $t('javascript.no_agreement_in_session', {session: sessionNumber}) }} <i style="font-size: 40px;" class="fa fa-exclamation-circle pull-right"></i></p>
      <p>{{ $t('javascript.no_agreement_in_session_2')}}</p>
    </simple-ok-modal>
  </div>
</template>

<script>
  import Slider from 'slider'
  import SHeader from 'components/header'
  import SAlert from 'components/alert'
  import Party from 'components/party'
  import SFooter from 'components/footer'
  import SButton from 'components/button'
  import SurveyModal from 'components/modals/survey'
  import EndSessionModal from 'components/modals/end_session'
  import AllDoneModal from 'components/modals/declare_all_done'
  import FinalSessionModal from 'components/modals/mark_session_final'
  import SimpleOkModal from 'components/modals/simple_ok'
  import { useStore } from 'vuex';
  //import getStore from "store/index"
  //import { storeToRefs } from 'pinia'
  import SSfAlert from 'components/alert_sf'
  import { ref, computed, watch, nextTick, onMounted, useTemplateRef} from 'vue';
  export default {
    name: 'quadro',
    props: {
      apiEndpoint: String, 
      caseId: String,
      credentials: String
    },
    components: {
      Slider, SHeader, Party, SFooter, SButton, SAlert, SSfAlert, SurveyModal,
      EndSessionModal, AllDoneModal, FinalSessionModal, SimpleOkModal
    },
    setup(props) {
      const store = useStore();
      const panelWidth = ref(1140); // 1140
      const firstFetchDone = ref(false);
      const surveyNotLoaded =  ref(false);
      const modalsOpen = ref( {
        endSession: false,
        allDone: false,
        finalSession: false,
        noAgreement: false,
        sessionNoAgreement: false,
        negCompleted: false,
      });
      const root = ref<HTMLElement | null>(null);
      const slider215 = useTemplateRef('slider215');
      const isFinalSession = computed(() => {
        return store.state.state.negoDetails?.session?.final_session === 'yes'
      });
      const otherPartyEndedSession = computed(() => {
        return opponentParty.has_ended_session === 'yes'
      });
      const showSurvey = computed(() => {
        return modalsOpen.value.negCompleted && surveyNotLoaded.value && ourParty.survey_completed != true && store.state.state.negoDetails.survey_id != null
      });
      const sessionNumber = computed(() => {
        return store.state.state.negoDetails.current_session_number || 0
      });
      const getDashboardLink = computed(() => {
        if (window.location.href.indexOf("enegotiation.org/dash") != -1){
          return "/dashboard/" + store.state.state.negoDetails.client_reference_id + "/negotiations"
        } else {
          return "/negotiations";
        }
      });
      const btnToShow = computed(() => {
        let params = store.state.state.negoDetails

        if (params.status === 'active_sessions' || params.status === 'intake' || params.status === 'agreement_setup') {

          // Help (only at the very beginning)
          // will advise the user to set her proposal by clicking on the green flag
          if(params.current_session_number <= 1 && params.your_party.has_ended_session === 'no' && !params.your_party.can_end_session) {
            return 'help'

            // Declare Final Session (show only at the beginning of each new session, except Session 1)
          } else if(params.current_session_number > 1 && params.your_party.has_ended_session === 'no' &&
            params.your_party.has_accepted === 'no' && params.your_party.has_proposed === 'no' &&
            params.session.final_session === 'no' ) {
            if (params.your_party.acceptance === params.other_party.visible){
	    	return 'end-to-agree'
	    } else {
            	return 'final-session'
	    }
            // All Done Session n (show after user makes first move in a session)
            // keep the automatic feature for secret acceptance (secret bid) as is
          } else if (((params.current_session_number > 1) && params.your_party.has_ended_session === 'no' && params.session.final_session != 'yes' && params.your_party.acceptance === params.other_party.visible)){
            return 'end-to-agree'
          } else if (params.your_party.has_ended_session === 'no' && params.your_party.can_end_session && params.session.final_session === 'no') {
            return 'end-session'

            // Cancel All Done (show after user declares all done (or auto all done), even in Final Session)
            // Declare Final Session (show only at the beginning of each new session, except Session 1)
          } else if(params.your_party.has_ended_session === 'yes' && params.session.final_session === 'no') {
            return 'cancel-end-session'

            // All Done Final Session (show in Final Session)
          } else if(params.session.final_session === 'yes' && params.your_party.has_declared_done === 'no' && params.your_party.has_ended_session === 'no') {
            return 'all-done'

            // Cancel All Done Final Session (show in Final Session)
          } else if(params.session.final_session === 'yes' && params.your_party.has_declared_done === 'no' && params.your_party.has_ended_session === 'yes') {
            return 'show-sgc'

          } else if(params.session.final_session === 'yes' && params.your_party.has_declared_done === 'yes') {
            return 'cancel-all-done'
          }
        } else if(params.status === 'no_agreement' && params.your_party.reset_request != true && params.allow_reset == true && (window.location.href.indexOf("enegotiation.org/dash") == -1)){
          return 'reset'
        } else if (params.your_party.reset_request === true){
          return 'cancel-reset'
        }
        return 'none'
      });
      const frameWorkRequiresAcceptance = computed(() => {
        console.log("frameWorkRequiresAcceptance");
        console.log(store.state.state.negoDetails);
        return store.state.state.negoDetails.your_party.af_status != 'accepted'
      });
      const flagsEnabled = computed(() => {
        return store.state.state.negoDetails.flags_enabled == false
      });
      const sfRequiresAcceptance = computed(() => {
        return store.state.state.negoDetails.your_party.reaccept_fee != false && (!negotiationCompleted || store.state.state.negoDetails.payment_location == "agreement_step")
      });
      const negotiationCompleted = computed(() => {
        modalsOpen.value.negCompleted = ['agreement', 'automated_agreement', 'end_agreement','no_agreement', 'cancelled'].includes(store.state.state.negoDetails.status)
        return [
          'agreement', 'automated_agreement', 'end_agreement','no_agreement', 'cancelled'
        ].includes(store.state.state.negoDetails.status)
      });
      const agreementReached = computed(() => {
        let tmp = ['agreement', 'automated_agreement', 'end_agreement'].includes(store.state.state.negoDetails.status)
        let ele = document.getElementById('negotiation-no-agreement-alert')
        let agreeEle = document.getElementById('negotiation-agreement-alert')
        if(tmp && agreeEle && agreeEle.classList.contains('d-none')){ 
          window.location.reload() //agreeEle.classList.remove('d-none')
        } 
        return tmp
      });
      const askForMediatorPerms = computed(() => {
        let mediatedCase = store.state.state.negoDetails.creator_type === 'mediator'
        let mediatorNotYetAllowedToSeeSecretBid = !store.state.state.negoDetails.your_party.show_secret_to_mediator
        return mediatedCase && mediatorNotYetAllowedToSeeSecretBid
      });
      const ourParty = computed(() => {
        return store.state.state.negoDetails.your_party || {}
      });
      const opponentParty = computed(() => {
        return store.state.state.negoDetails.other_party || {}
      });
      const adcExtension = computed(() => {
        let diff = Math.abs(issueDetailList[0]?.preferred_value - issueDetailList[0]?.unpreferred_value)
        return Math.round(diff * 0.1)
      });
      const adcUnit = computed(() => {
        return issueDetailList[0]?.issue_format_and_units
      });
      const issueDetailList = computed(() => {
        let list = []
        let issueKey = ''
        let ids = store.state.state.negoDetails.issue_ids
        let params = store.state.state.negoDetails.slider_grids_params
        if (!params) return []
        for (let id of ids) {
          issueKey = 'issue_' + id
          if (params[issueKey]) {
            list.push(params[issueKey])
          }
        }
        return list
      });
      const negoDetails = computed(() => {
        console.log("quadro - negoDetails")
        console.log(store.state.state.negoDetails)
        return store.state.state.negoDetails
      });
      const allowMediatorToSeeSecret = async () => {
        try {
          await store.dipatch('allowMediatorToSeeSecret', {})
        } catch {}
      };
      const endSession = async (resp) => {
	modalsOpen.value.endSession = false
        try {
          await store.dispatch('endSession', {secret_bid_extension: resp.extension})
        } catch {}
      };
      const declareAllDone = async (resp) =>{
        modalsOpen.value.allDone = false
        console.log("quadro - declareAllDone")
        try { // endFinalSession (alternative method name)
          await store.dispatch('declareAllDone', {arbitration: resp.arbitrationAccepted, secret_bid_extension: resp.extension})
        } catch {}
      };
      const checkAgreement = async () => {
        try { // endFinalSession (alternative method name)
          if (isFinalSession){
            console.log("checkAgreement inside");
            let details = await store.dispatch('checkAgreement', {})
	    console.log(details);
            console.log("details");
            if (store.state.state.negoDetails.your_party.acceptance_locked == 'yes'){
	      console.log("locked in checkAgreement")
              modalsOpen.value.allDone = true
            }
          } else {
            modalsOpen.value.endSession = true
          }
        } catch {}
      };
      const openSgc = async () => {
        console.log("quadro - openSgc")
        try { // endFinalSession (alternative method name)
          modalsOpen.value.allDone = true
          await store.dispatch('checkAgreement', {})
        } catch {}
      };
      const markSessionAsFinal = async () => {
        try {
          await store.dispatch('declareFinalSession', {arbitration: false})
          modalsOpen.finalSession = false
        } catch {}
      };
      const cancelEndSession = async () => {
        try {
          await store.dispatch('cancelEndSession', {})
        } catch {}
      };
      const cancelDeclareAllDone = async () => {
        try {
          await store.dispatch('cancelAllDone', {})
        } catch {}
      };
      const savePosition = async (method, value, issueId) => {
        let sliderRefId = 'slider' + issueId
        try {
          await store.dispatch('savePosition', {method: method, value: value, issueId: issueId})
        } catch {
          // Reset last move
          slider215.setFlagsToFitData()
        }
      };
      const surveyOk = async () => {
        surveyNotLoaded.value = false
      };
      const setApiEndpoint = async () => {
        store.commit('setEndpoint', {endpoint: props.apiEndpoint, creds: props.credentials})
      };
      const setPanelWidth = async () => {
        let parent = root.parentNode
        console.log("setPanelWidth");
        console.log(store);
        panelWidth.value = (1140) - 2*15  // width - 2*margin
      };
      const fetchData = async () => {
        // Fetch the data from the backend
        await store.dispatch('fetchData', {caseId: props.caseId, mediated: false})
      };
      const setSurveyModal = async () => {
        await sleep(5000)
        surveyNotLoaded.value = true
      };
      const fetchDataForever = async () => {
        await fetchData()
        firstFetchDone.value = true

        console.log('negoDetails.arbitration_enabled')
        console.log(negoDetails.arbitration_enabled)
        console.log('opponentParty.arbitration_accepted')
        console.log(opponentParty.arbitration_accepted)
        console.log(negoDetails)
        // noinspection InfiniteLoopJS
        while (true) {
          await fetchData()
          await sleep(5000)
        }
      };
      const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
      watch(() => sessionNumber, (sessionNr, oldSessionNr) =>{
        if ( !firstFetchDone.value ) return

        if ((sessionNr > oldSessionNr) && (sessionNr > 1)) {
          let scope = this
          modalsOpen.value.sessionNoAgreement = true
          setTimeout(function () {
            scope.modalsOpen.value.sessionNoAgreement = false
          }, 5000);
        }
      });
      watch(() => negotiationCompleted, (val, oldVal) =>{
        if (val === oldVal || !firstFetchDone.value) return

        if (val && negoDetails.status === 'no_agreement') {
          let ele = document.getElementById('negotiation-no-agreement-alert')
          if(ele && ele.classList.contains('d-none')){
            window.location.reload() //agreeEle.classList.remove('d-none')
          }
          //this.modalsOpen.noAgreement = true
        }
      });
      setApiEndpoint()
      fetchDataForever()
      setSurveyModal()
      onMounted(() => {
        setPanelWidth()
      });
      return {
        store,
        panelWidth,
        firstFetchDone,
        surveyNotLoaded,
        modalsOpen,
        isFinalSession,
        otherPartyEndedSession,
        showSurvey,
        sessionNumber,
        getDashboardLink,
        btnToShow,
        frameWorkRequiresAcceptance,
        flagsEnabled,
        sfRequiresAcceptance,
        negotiationCompleted,
        agreementReached,
        askForMediatorPerms,
        ourParty,
        opponentParty,
        adcExtension,
        adcUnit,
        issueDetailList,
        negoDetails,
        allowMediatorToSeeSecret,
        endSession,
        declareAllDone,
        checkAgreement,
        openSgc,
        markSessionAsFinal,
        cancelEndSession,
        cancelDeclareAllDone,
        savePosition,
        surveyOk,
        setApiEndpoint,
        setPanelWidth,
        fetchData,
        setSurveyModal,
        fetchDataForever,
      };
    }
  };
</script>

<style scoped>
  .error-msg {
    color: #ff3939;
  }
  .offline-msg {
    color: orange;
  }
</style>
